import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import BenefitsSection from './components/BenefitsSection';
import CategoryGrid from './components/CategoryGrid';
import ComparisonSection from './components/ComparisonSection';
import SEOSection from './components/SEOSection';
import TestimonialSection from './components/TestimonialSection';
import FinalCTASection from './components/FinalCTASection';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://yoybuy.quest';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'YOYBUY Spreadsheet',
  url: siteUrl,
  description: 'YOYBUY Spreadsheet — самый удобный способ заказывать товары из Китая через простую таблицу. Прозрачные комиссии, быстрая доставка, полный контроль заказов с Taobao и 1688.',
  inLanguage: 'ru',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteUrl}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <JsonLd data={homeJsonLd} />
      <Navbar />
      <main>
        <HeroSection />
        <BenefitsSection />
        <CategoryGrid />
        <ComparisonSection />
        <SEOSection />
        <TestimonialSection />
        <FinalCTASection />
      </main>
      <Footer />
    </>
  );
}